import { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import ProgressBar from '../Components/ProgressBar.jsx';
import './InternalFormPage.css';
import axios from 'axios';

const formRoute = process.env.REACT_APP_INTERNAL_FORM;
const salespeople = process.env.REACT_APP_SALESPEOPLE_OPTIONS.split(',');


const formOptions = [
    'New Account Application',
    'COD Credit Application',
    'New Owner (TO) Credit Application',
    'New Owner (NA) Credit Application',
];

const CustomSelect = ({ value, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="custom-select-container">
            <div
                className="custom-select-display"
                onClick={() => setIsOpen(prev => !prev)}
            >
                {value || '-- Choose a Form --'}
                <span className="arrow">{isOpen ? '▲' : '▼'}</span>
            </div>

            <AnimatePresence>
                {isOpen && (
                    <motion.ul
                        className="custom-options-list"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.2 }}
                    >
                        {formOptions.map((option) => (
                            <li
                                key={option}
                                className="custom-option"
                                onClick={() => {
                                    onChange(option);
                                    setIsOpen(false);
                                }}
                            >
                                {option}
                            </li>
                        ))}
                    </motion.ul>
                )}
            </AnimatePresence>
        </div>
    );
};

const SalespersonSelect = ({ value, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="custom-select-container">
            <div
                className="custom-select-display"
                onClick={() => setIsOpen(prev => !prev)}
            >
                {value || '-- Salesperson --'}
                <span className="arrow">{isOpen ? '▲' : '▼'}</span>
            </div>

            <AnimatePresence>
                {isOpen && (
                    <motion.ul
                        className="custom-options-list"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.2 }}
                    >
                        {salespeople.map((option) => (
                            <li
                                key={option}
                                className="custom-option"
                                onClick={() => {
                                    onChange(option);
                                    setIsOpen(false);
                                }}
                            >
                                {option}
                            </li>
                        ))}
                    </motion.ul>
                )}
            </AnimatePresence>
        </div>
    );
}


const InternalFormPage = () => {

    const navigate = useNavigate();
    const [formType, setFormType] = useState('');
    const [formData, setFormData] = useState({
        customerType: [],
        customerName: '',
        customerEmail: '',
        salesperson: '',
        currentAccount: '',
    });
    const [isReviewing, setIsReviewing] = useState(false);
    const [toast, setToast] = useState({ type: '', message: '' });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [progress, setProgress] = useState(0);

    const { accounts } = useMsal();
    const userEmail = accounts[0]?.username;

    const handleChange = (field) => (e) => {
        setFormData({ ...formData, [field]: e.target.value });
    };

    const renderFields = () => {
        switch (formType) {
            case 'New Account Application':
                // if New Account Application is chosen, one of these MUST be selected                
                return (
                    <>
                        <div className="form-field">
                            <fieldset style={{ border: 'none' }}>
                                <legend style={{ fontWeight: 'bold', textAlign: 'center', fontSize: 'larger' }}>Customer Type</legend>
                                <div className="radio-group">
                                    <label htmlFor="personal">
                                        <input
                                            type="radio"
                                            id="personal"
                                            name="customerType"
                                            value="Personal"
                                            checked={formData.customerType === 'Personal'}
                                            onChange={handleChange('customerType')}
                                            required={formType === 'New Account Application'}
                                        />
                                        Personal
                                    </label>
                                    <label htmlFor="commercial">
                                        <input
                                            type="radio"
                                            id="commercial"
                                            name="customerType"
                                            value="Commercial"
                                            checked={formData.customerType === 'Commercial'}
                                            onChange={handleChange('customerType')}
                                            required={formType === 'New Account Application'}
                                        />
                                        Commercial
                                    </label>
                                </div>
                            </fieldset>
                        </div>

                        {commonFields()}
                    </>
                );
            case 'COD Credit Application':
                return commonFields();
            case 'New Owner (TO) Credit Application':
            case 'New Owner (NA) Credit Application':
                return (
                    <>
                        <div className="request-form-field">
                            <label htmlFor="currentAccount">Current TIMS Account</label>
                            <input type="text" id="currentAccount" placeholder="ABCD" name='currentAccount' value={formData.currentAccount} onChange={handleChange('currentAccount')} />
                        </div>

                        {commonFields()}
                    </>
                );
            default:
                return null;
        }
    };

    const commonFields = () => (
        <>
            <div className="request-form-field">
                <label htmlFor="customerName">Customer Name</label>
                <input id="customerName" name="customerName" placeholder="John Smith" type="text" value={formData.customerName} onChange={handleChange('customerName')} />
                <label htmlFor="customerEmail">Customer Email</label>
                <input id="customerEmail" name="customerEmail" placeholder="john.smith@example.com" type="email" value={formData.customerEmail} onChange={handleChange('customerEmail')} />
            </div>
            <SalespersonSelect value={formData.salesperson} onChange={(val) => setFormData(prev => ({ ...prev, salesperson: val }))} />

        </>
    );


    const handleSubmit = (e) => {
        e.preventDefault();
        setIsReviewing(true); // show modal instead of submitting directly
    };



const handleModalSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    setIsReviewing(false);
    setProgress(0);

    let progressTimer;

      progressTimer = setInterval(() => {
    setProgress((prev) => {
      // stop creeping once ~90%, leave last jump for real success/failure
      if (prev < 90) {
        return prev + 5; // creep up by 5% every tick
      }
      return prev;
    });
  }, 400);

    // Safely trim the salesperson to just the ID
    const trimmedSalesperson = formData.salesperson?.split(' - ')[0]?.trim() || '';
  let outgoingFormType = formType;

  // If it’s a New Account, append the customerType
  if (formType === 'New Account Application' && formData.customerType) {
    outgoingFormType = `${formType} - ${formData.customerType}`;
  }

  // Build the payload
  const payload = {
    formType: outgoingFormType,
        formData: {
            customerName: formData.customerName,
            customerEmail: formData.customerEmail,
            salesperson: trimmedSalesperson,
            customerType: formType === 'New Account Application' ? formData.customerType : null,
            currentAccount: formType.includes('New Owner') ? formData.currentAccount : null,
            submittedBy: userEmail || 'unknown',
        }
    };

    if (formType === 'New Account Application') {
        payload.customerType = formData.customerType;
    }

    if (formType.includes('New Owner')) {
        payload.currentAccount = formData.currentAccount;
    }
    

    try {
        const response = await axios.post(
            formRoute,
            payload,
            
            {
                headers: { 'Content-Type': 'application/json' },
                      onUploadProgress: (progressEvent) => {
        if (progressEvent.total) {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgress(percent);
        }
      },
            }
        );

        console.log('Form submission response:', response.data);

        setToast({ type: 'success', message: 'Form submitted successfully!' });

        // Reset state
        setFormType('');
        setFormData({
            customerType: '',
            customerName: '',
            customerEmail: '',
            salesperson: '',
            currentAccount: '',
        });
    } catch (err) {
        console.error(err);
        setToast({ type: 'error', message: 'There was an error submitting the form.' });
    } finally {
        clearInterval(progressTimer);
        setProgress(100);
        setIsSubmitting(false);
    }

    setTimeout(() => {
        setToast({ type: '', message: '' });
    }, 7000);
};

useEffect(() => {
  let interval;
  const duration = 90000; // 90 seconds
  const targetProgress = 95;
  const startTime = Date.now();

  if (isSubmitting) {
    setProgress(0);
    interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const fraction = Math.min(elapsed / duration, 1);
      const nextProgress = Math.floor(fraction * targetProgress);
      setProgress(prev => (nextProgress > prev ? nextProgress : prev));
    }, 10000); // Add a tick interval of 10 seconds
  }

  return () => clearInterval(interval);
}, [isSubmitting]);

    return (
        <div className="internal-form-wrapper">
            <button className="back-button" onClick={() => navigate('/')}>⬅  Back to Dashboard</button>
            <h2>Customer Credit Applications</h2>

            <CustomSelect value={formType} onChange={(val) => setFormType(val)} />

            {formType && (
                <form className="form-container" onSubmit={handleSubmit}>
                    {renderFields()}
                    <div className="submit-button-container">
                        <button className="submit-button" type="submit">Submit</button>
                    </div>
                </form>
            )}

            {isSubmitting && <ProgressBar progress={progress} text={`Submitting Form and Creating Applicant... ${progress}%`} />}

            <div style={{ textAlign: 'center', marginTop: '.5rem' }}>
                <p style={{ fontSize: '0.9rem', color: '#666', fontStyle: 'italic', fontWeight: 'bold', paddingTop: '1rem' }}>
                    This form generates automated actions, use with caution.
                </p>
                <p style={{ fontSize: '0.9rem', color: '#666', fontStyle: 'italic', fontWeight: 'bold' }}>NOTE: FOR INTERNAL USE ONLY.</p>
            </div>


            {isReviewing && (
                <div className="modal-backdrop">
                    <div className="internal-modal">
                        <h3>Review Your Submission</h3>
                        <ul className="review-list">
                            <li><strong>Form Type:</strong> {formType} - {formData.customerType}</li>
                            {formType.includes('New Account Application') && (
                                <li><strong>Customer Type:</strong> {formData.customerType}</li>
                            )}
                            <li><strong>Customer Name:</strong> {formData.customerName}</li>
                            <li><strong>Customer Email:</strong> {formData.customerEmail}</li>
                            <li><strong>Salesperson:</strong> {formData.salesperson}</li>
                            {formType.includes('New Owner') && (
                                <li><strong>Current Account:</strong> {formData.currentAccount}</li>
                            )}
                        </ul>

                        <div className="modal-actions">
                            <button
                                className="cancel-button"
                                onClick={() => setIsReviewing(false)}
                            >
                                Continue Editing
                            </button>
                            <button
                                className="confirm-button"
                                onClick={(e) => {
                                    e.preventDefault(); // prevent default button behavior
                                    handleModalSubmit();
                                }}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? "Submitting..." : "Confirm and Submit"}
                            </button>


                        </div>
                    </div>
                </div>
            )}

            {toast.message && (
                <div className={`toast ${toast.type}`}>
                    {toast.message}
                </div>
            )}

        </div>
    );

};

export default InternalFormPage;
